import { useState } from 'react';

const testimonials = [
  {
    name: 'Sarah M.',
    location: 'Lubbock, TX',
    rating: 5,
    text: 'Sweet Celebrations made our daughter\'s birthday cake absolutely magical! Sherry nailed every detail of the design we requested. The cake was not only stunning but tasted incredible. Every guest was asking for her information. We will never order from anywhere else!',
    avatar: 'https://public.readdy.ai/ai/img_res/a77623ae2d6bbbc3c8401631e2aee3ef.jpg',
  },
  {
    name: 'Jessica & Tyler W.',
    location: 'Lubbock, TX',
    rating: 5,
    text: 'Our wedding cake was a showstopper! We came to Sherry with a vision and she brought it to life better than we ever imagined. The floral details were breathtaking and the flavor was absolutely divine. Our guests are still talking about it months later.',
    avatar: 'https://readdy.ai/api/search-image?query=happy%20smiling%20couple%20portrait%20warm%20background%20natural%20lighting%20friendly%20and%20welcoming%20appearance&width=80&height=80&seq=av002&orientation=squarish',
  },
  {
    name: 'Amanda R.',
    location: 'Lubbock, TX',
    rating: 5,
    text: 'I took the cake decorating class and left feeling like a true artist! The instruction was so hands-on, patient, and encouraging. The cheesecakes are also out of this world — I order them every holiday season. Sweet Celebrations is truly a Lubbock treasure.',
    avatar: 'https://readdy.ai/api/search-image?query=smiling%20mature%20woman%20portrait%20headshot%20warm%20lighting%20simple%20background%20friendly%20professional&width=80&height=80&seq=av003&orientation=squarish',
  },
  {
    name: 'Maria L.',
    location: 'Lubbock, TX',
    rating: 5,
    text: 'The custom cookies for my baby shower were PERFECT. They matched the theme exactly and tasted as amazing as they looked. Sherry is so talented and easy to work with. Highly recommend to anyone looking for something truly special!',
    avatar: 'https://readdy.ai/api/search-image?query=happy%20smiling%20young%20latina%20woman%20portrait%20headshot%20casual%20warm%20background%20natural%20lighting&width=80&height=80&seq=av004&orientation=squarish',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-20 md:py-28 bg-blush-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-10 bg-gold-500" />
            <span className="text-gold-500 text-xs uppercase tracking-[0.25em] font-sans font-semibold">What Our Customers Say</span>
            <div className="h-px w-10 bg-gold-500" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal-800">
            Loved by <em className="italic text-blush-500">Lubbock</em>
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="bg-white rounded-2xl p-8 md:p-12 relative">
          {/* Quote marks */}
          <div className="absolute top-6 left-8 font-serif text-8xl text-blush-200 leading-none select-none">&ldquo;</div>

          {/* Stars */}
          <div className="flex gap-1 mb-6">
            {Array.from({ length: t.rating }).map((_, i) => (
              <i key={i} className="ri-star-fill text-gold-500 text-lg" />
            ))}
          </div>

          {/* Quote */}
          <p className="font-serif text-lg md:text-xl text-charcoal-800 leading-relaxed mb-8 relative z-10">
            {t.text}
          </p>

          {/* Customer */}
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="text-charcoal-800 font-sans font-bold text-base">{t.name}</p>
                <p className="text-warm-gray text-sm font-sans">{t.location}</p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 flex items-center justify-center rounded-full border border-warm-200 text-charcoal-700 hover:bg-blush-500 hover:text-white hover:border-blush-500 transition-all duration-200 cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-s-line text-xl" />
              </button>
              <button
                onClick={next}
                className="w-11 h-11 flex items-center justify-center rounded-full bg-charcoal-800 text-white hover:bg-blush-500 transition-all duration-200 cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-s-line text-xl" />
              </button>
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all duration-200 cursor-pointer ${
                  i === current ? 'w-6 h-2 bg-blush-500' : 'w-2 h-2 bg-warm-200'
                }`}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
